import { render } from "./SearchRect.vue?vue&type=template&id=dd19a040"
import script from "./SearchRect.vue?vue&type=script&lang=js"
export * from "./SearchRect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jeongyunl/Documents/GitHub/datamap-search/vue-for-django/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__